import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faPlus,
  faCalendar,
  faFilter,
  faSun,
  faMap,
  faCircleDot,
  faStopwatch,
  faChair,
  faUsers,
  faCircleXmark,
  faFilePen,
  faRectangleXmark,
  faEnvelope,
  faWheelchairMove,
  faBaby,
  faBell,
  faReply,
  faSearch,
  faSquareCheck,
  faEye,
  faPhone,
  faCircleCheck,
  faGear,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Card, Modal, Button, ModalBody } from "react-bootstrap";
import styled from "styled-components";
import {
  postReservationAccept,
  updateReservationStatus,
  changeTableNumber,
  sendTableReadyMessage,
} from "../actions/restaurantActions";
import {
  fetchCancelReservation,
  checkCancelAction,
  updateReservation,
  ResetReservation,
} from "../actions/reservationsActions";
import moment from "moment-timezone";
import CompareChanges from "./CompareChanges";
import {
  getReservationStatusTranslation,
  cancelledDidNotAttendStatuses,
  getReservationStatusAbreviationTranslation,
  getReservationStatusColors,
  acceptedStatuses,
  pendingStatuses,
} from "./ReservationStatus";
import StatusDropdown from "./StatusDropdown";
import { ConfirmationModal } from "./DefaultImports";

const StyledReservationStatusBox = styled.div`
  display: flex;
  width: 300px;
  height: 70px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-right: 10px;
  position: absolute;
  right: 0px;
  bottom: 0;
`;

const TopBox = styled.div`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  font-size: 17px;
  width: 100px;
  height: 60px;
  font-weight: bold;
  right: 0;
  bottom: 0;
  color: ${(props) =>
    props.status === "Cancelled" ||
    props.status === "cancelled_customer" ||
    props.status === "cancelled_restaurant" ||
    props.status === "no_show"
      ? "#e8733c"
      : props.status === "Pending_from_customer_Warning"
        ? "#d6a7c1"
        : props.status === "Edited"
          ? "#7e538a"
          : props.status === "waiting_list"
            ? "#7e538a"
            : props.status === "pending_restaurant"
              ? "#cacf44"
              : props.status === "pending_customer"
                ? "#959657"
                : props.status === "late"
                  ? "#ebb052"
                  : "#58c49f"};

  @media (max-width: 768px) {
    font-size: 18px;
    height: 90px;
  }
`;

const TextButtomBox = styled.div`
  width: 240px;
  height: 70px;
  left: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  align-items: center;
`;

const TittleWrapper = styled.div`
  width: 100%;
  height: 30px;
  position: relative;
  align-items: center;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  color: ${(props) => props.color};
  font-size: clamp(10px, 2.5vw, 16px); /* ⬅️ Responsive but max 14px */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: clamp(
      10px,
      3.5vw,
      16px
    ); // even more responsive on small screens
  }
`;

const ButtonsWrapper = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: end;
`;

const LeftButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 100%;
  padding: 0px 3px 0px 3px;
  border-radius: 5px;
  background-color: #faf6e9;
  color: #ee754c;
  z-index: 1;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: #faf6e9;
  }
`;

const RightButton = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 0px 3px 0px 3px;
  height: 100%;
  background-color: #ee754c;
  color: #faf6e9;
  margin-left: 10px;
  border-radius: 5px;
  z-index: 1;
  white-space: nowrap;

  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: rgb(241, 137, 102);
  }
`;

const FullButton = styled.div`
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30px;
  background-color: #99b0ad;
  color: #faf6e9;
  z-index: 1;
  cursor: pointer;
  border-radius: 6px;
  &:hover {
    background-color: rgb(174, 194, 191);
  }
`;

const Circle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #99b0ad;
  color: #faf6e9;
  cursor: pointer;
  z-index: 4;
  margin-left: 10px;
  position: absolute;
  right: 0;
  bottom: 0;
  &:hover {
    background-color: #ededed;
  }
  @media (max-width: 768px) {
  }
`;

const NumberBoxes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border: 1px solid gray;
  border-radius: 4px;
  background-color: white;
  color: black;
  margin: 5px;
  cursor: pointer;
  &:hover {
    background-color: #ededed;
  }
`;

const DropdownTrigger = styled.div`
  width: 100%;
  height: 30px;
  position: relative;
  align-items: center;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  color: ${(props) => props.color};
  font-size: clamp(10px, 2.5vw, 16px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: clamp(10px, 3.5vw, 16px);
  }
`;

const PortalDropdown = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  min-width: 180px;
  z-index: 3000;
  padding: 4px 0;
`;

const DropdownItem = styled.div`
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: #f0f0f0;
  }
`;

function ReservationStatusBox({
  reservation,
  index,
  statusBoxRef = null,
  reservations,
  setTokens = false,
  isShowCustomerInfo,
}) {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [numbers, setNumbers] = useState(
    Array.from({ length: 101 }, (_, index) => index),
  );
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showSendTableReadyMessageModal, setShowSendTableReadyMessageModal] =
    useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showAttendanceOptions, setShowAttendanceOptions] = useState(false);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [showNotAttendanceModal, setShowNotAttendanceModal] = useState(false);
  const [showModalRestoreReservation, setShowModalRestoreReservation] =
    useState(false);
  const [showChangeTablesModal, setShowChangeTablesModal] = useState(false);
  const [rejectEdition, setRejectEdition] = useState(false);
  const [reservationBeforeEdition, setReservationBeforeEdition] =
    useState(null);

  const [notify_customer, setNotify_customer] = useState(true);

  const [isButtons, setIsButtons] = useState(false);

  const [reservationToChangeToken, setReservationToChangeToken] = useState("");
  const [reservationToChangeName, setReservationToChangeName] = useState("");
  const [reservationToChangeNumber, setReservationToChangeNumber] =
    useState("");

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);

  const allowedStatuses = [
    "accepted",
    "pending_restaurant",
    "late",
    "waiting_list",
    "cancelled_restaurant",
    "cancelled_customer",
  ];

  const crudManagerPermissions = useSelector((state) => state.crudManager);
  const { managerInfo } = crudManagerPermissions;

  useEffect(() => {
    if (
      reservation &&
      typeof reservation === "object" &&
      Array.isArray(reservation.history) &&
      typeof reservation.restore_version_id !== "undefined"
    ) {
      const filteredHistoryItem = reservation.history.find(
        (item) =>
          item &&
          typeof item === "object" &&
          item.history_id === reservation.restore_version_id,
      );

      setReservationBeforeEdition(filteredHistoryItem || null);
    } else {
      setReservationBeforeEdition(null);
    }
  }, [reservation]);

  const restaurantTimeZone = useSelector(
    (state) => state.reservationBlockedWeekDays.restaurantTimeZone,
  );

  useEffect(() => {
    if (restaurantTimeZone) {
      const currentTime = moment.tz(restaurantTimeZone.timezone);
      const currentTimeToShowAttendance = currentTime.clone().add(24, "hours");
      const currentTimeAfter = currentTime.clone().subtract(15, "minutes");
      const reservationDateTime = moment.tz(
        `${reservation.date} ${reservation.time}`,
        "YYYY-MM-DD HH:mm",
        restaurantTimeZone.timezone,
      );
      if (reservationDateTime.isBefore(currentTimeToShowAttendance)) {
        setShowAttendanceOptions(true);
      }
    }
  }, [restaurantTimeZone, reservation, index]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChangeTable = (
    number,
    isNotAllowed,
    reservation_name,
    reservation_token,
  ) => {
    if (!isNotAllowed) {
      let status;
      if (number !== null && reservation.status === "Accepted_Without_Table") {
        status = "Accepted_With_Table";
      } else if (reservation.status === "Accepted_With_Table") {
        status = "Accepted_Without_Table";
      } else {
        status = reservation.status;
      }

      if (reservation.status == "waiting_list") {
        setShowSendTableReadyMessageModal(true);
      }

      dispatch(changeTableNumber(reservation.token, number));
      setShowModal(false);
    } else {
      setReservationToChangeNumber(number);
      setReservationToChangeToken(reservation_token);
      setReservationToChangeName(reservation_name);
      setShowChangeTablesModal(true);
    }
  };

  const sendTheTableReadyMessage = () => {
    dispatch(sendTableReadyMessage(reservation.token));
    setShowSendTableReadyMessageModal(false);
  };

  const changeTablesWithOtherReservation = () => {
    if (reservation.status == "waiting_list") {
      setShowSendTableReadyMessageModal(true);
    }
    dispatch(changeTableNumber(reservation.token, reservationToChangeNumber));
    dispatch(
      changeTableNumber(reservationToChangeToken, reservation.table_number),
    );
    setShowChangeTablesModal(false);
    setShowModal(false);
  };

  const handleShowAcceptModal = (str) => {
    if (str === "rejectEdition") {
      setRejectEdition(true);
    } else {
      setRejectEdition(false);
    }
    setShowAcceptModal(true);
  };

  const handleCloseAcceptModal = () => {
    setShowAcceptModal(false);
  };

  const handleShowCancelModal = (str) => {
    if (str === "rejectEdition") {
      setRejectEdition(true);
    } else {
      setRejectEdition(false);
    }
    setShowCancelModal(true);
  };

  const handleCloseCancelModal = () => {
    setShowCancelModal(false);
  };

  const handleAccept = () => {
    let status;
    if (
      reservation.table_number !== "" ||
      reservation.table_number !== "null" ||
      reservation.table_number !== null
    ) {
      status = "Accepted_With_Table";
    } else {
      status = "Accepted_Without_Table";
    }
    if (rejectEdition) {
      dispatch(
        postReservationAccept(reservation.token, false, true, notify_customer),
      );
    } else {
      dispatch(
        postReservationAccept(reservation.token, false, false, notify_customer),
      );
    }
    setShowAcceptModal(false);
    if (setTokens != false) {
      setTokens("");
    }
  };

  const handleCancel = () => {
    let status = "cancelled_restaurant";

    setShowCancelModal(false);
    if (rejectEdition) {
      dispatch(fetchCancelReservation(reservation.id, false, false, true));
    } else {
      dispatch(fetchCancelReservation(reservation.id, false, false, false));
    }
    if (setTokens != false) {
      setTokens("");
    }
  };

  const handleCheckCancel = (token) => {
    dispatch(checkCancelAction(token));
    if (setTokens != false) {
      setTokens("");
    }
  };

  const handleAttended = (token) => {
    dispatch(updateReservationStatus(reservation.id, "attended"));
    setShowAttendanceModal(false);
    setTokens("");
  };

  const handleNotAttended = (token) => {
    dispatch(updateReservationStatus(reservation.id, "no_show"));
    setShowNotAttendanceModal(false);
    if (setTokens != false) {
      setTokens("");
    }
  };

  const handleShowAttendanceModal = () => {
    setShowAttendanceModal(true);
  };

  const handleHideAttendanceModal = () => {
    setShowAttendanceModal(false);
  };

  const handleShowDidNotAttendanceModal = () => {
    setShowNotAttendanceModal(true);
  };

  const handleHideDidNotAttendanceModal = () => {
    setShowNotAttendanceModal(false);
  };

  const handleShowModalRestoreReservation = () => {
    setShowModalRestoreReservation(true);
  };

  const handleHideModalRestoreReservation = () => {
    setShowModalRestoreReservation(false);
  };

  const handleRestoreCancel = (token) => {
    let status;

    if (
      reservation.table_number !== "" ||
      reservation.table_number !== "null" ||
      reservation.table_number !== null
    ) {
      status = "Accepted_With_Table";
    } else {
      status = "Accepted_Without_Table";
    }
    dispatch(updateReservationStatus(reservation.id, "waiting_list"));
    setShowModalRestoreReservation(false);
    if (setTokens != false) {
      setTokens("");
    }
  };

  // Step 1: Define a function to check time overlap
  const checkOverlap = (
    newStartTime,
    newEndTime,
    existingStartTime,
    existingEndTime,
  ) => {
    return newStartTime <= existingEndTime && newEndTime >= existingStartTime;
  };

  const markNotAllowedTables = () => {
    if (reservations) {
      // Assuming you're using today's date for the base date
      const baseDate = new Date().toISOString().substring(0, 10); // "YYYY-MM-DD"

      const existingStartTime = new Date(`${baseDate}T${reservation.time}:00`); // Adds the base date to the time
      const existingEndTime = new Date(
        `${baseDate}T${reservation.estimatedtime}:00`,
      ); // Adds the base date to the estimated time

      // Filter reservations to exclude those with canceled statuses
      const activeReservations = reservations.filter(
        (reservation) =>
          !cancelledDidNotAttendStatuses.includes(reservation.status),
      );

      const markedNumbers = numbers.map((number) => {
        let reservation_name;
        let reservation_token;

        // Check for overlaps only in active reservations
        const isNotAllowed = activeReservations.some((reservation) => {
          if (reservation.table_number === number.toString()) {
            const newStartTime = new Date(`${baseDate}T${reservation.time}:00`);
            const newEndTime = new Date(
              `${baseDate}T${reservation.estimatedtime}:00`,
            );
            reservation_name = reservation.full_name;
            reservation_token = reservation.token;
            return checkOverlap(
              newStartTime,
              newEndTime,
              existingStartTime,
              existingEndTime,
            );
          }
          return false;
        });

        return { number, isNotAllowed, reservation_name, reservation_token };
      });

      return markedNumbers;
    }
  };

  // Call filterTableNumbers when you need to, such as on component mount or when reservations change
  useEffect(() => {
    if (reservations) {
      markNotAllowedTables();
    }
  }, [reservations, reservation]);

  const patchReservationStatus = async (reservation_id, newStatus) => {
    dispatch(updateReservationStatus(reservation_id, newStatus));
    setShowChangeStatusModal(false);
  };

  return (
    <>
      <StyledReservationStatusBox>
        {reservations ? (
          <>
            <Circle
              onClick={() => {
                // Check if the reservation status is NOT in the cancelledDidNotAttendStatuses array
                if (
                  !cancelledDidNotAttendStatuses.includes(reservation.status)
                ) {
                  setShowModal(!showModal);
                }
              }}
            >
              {/* Show table number only if it is not null or 'null' */}
              {reservation.table_number && reservation.table_number !== "null"
                ? reservation.table_number
                : ""}
            </Circle>
          </>
        ) : (
          <></>
        )}

        {!isShowCustomerInfo ? (
          <>
            <TextButtomBox>
              <StatusDropdown
                reservation={reservation}
                allowedStatuses={[
                  "accepted",
                  "pending_restaurant",
                  "Awaiting_customer_reconfirmation",
                  "late",
                  "waiting_list",
                  "cancelled_restaurant",
                  "cancelled_customer",
                ]}
                getStatusColor={getReservationStatusColors}
                getStatusLabel={getReservationStatusAbreviationTranslation}
                onSelectStatus={(status) => {
                  setSelectedStatus(status);
                  setShowChangeStatusModal(true); // open confirmation modal
                }}
              />

              {pendingStatuses.includes(reservation.status) && (
                <ButtonsWrapper>
                  <LeftButton onClick={() => handleShowAcceptModal()}>
                    Aceitar
                  </LeftButton>
                  <RightButton onClick={() => handleShowCancelModal()}>
                    Rejeitar
                  </RightButton>
                </ButtonsWrapper>
              )}

              {managerInfo && !managerInfo.change_status ? (
                <></>
              ) : (
                reservation.status === "Edited" && (
                  <ButtonsWrapper>
                    <LeftButton
                      onClick={() => handleShowAcceptModal("rejectEdition")}
                    >
                      Aceitar
                    </LeftButton>
                    <RightButton
                      onClick={() => handleShowCancelModal("rejectEdition")}
                    >
                      Rejeitar
                    </RightButton>
                  </ButtonsWrapper>
                )
              )}

              {managerInfo && !managerInfo.change_status ? (
                <></>
              ) : acceptedStatuses.includes(reservation.status) &&
                showAttendanceOptions ? (
                <ButtonsWrapper>
                  <LeftButton onClick={handleShowAttendanceModal}>
                    Compareceu
                  </LeftButton>
                  <RightButton onClick={handleShowDidNotAttendanceModal}>
                    Não Compareceu
                  </RightButton>
                </ButtonsWrapper>
              ) : (
                <></>
              )}

              {managerInfo && !managerInfo.change_status ? (
                <></>
              ) : reservation.cancelled_warning === true ? (
                <FullButton
                  onClick={() => handleCheckCancel(reservation.token)}
                >
                  <FontAwesomeIcon
                    size="xl"
                    icon={faEye}
                    style={{ color: "#ffffff", marginLeft: "10px" }}
                  />
                </FullButton>
              ) : reservation.status === "attended" ||
                reservation.status === "no_show" ||
                reservation.status === "Cancelled" ||
                reservation.status === "cancelled_customer" ||
                reservation.status === "cancelled_restaurant" ? (
                <FullButton
                  status={reservation.status}
                  onClick={handleShowModalRestoreReservation}
                >
                  <FontAwesomeIcon
                    size="xl"
                    icon={faReply}
                    style={{ color: "#ffffff", marginLeft: "10px" }}
                  />
                </FullButton>
              ) : null}
            </TextButtomBox>
          </>
        ) : null}
      </StyledReservationStatusBox>

      {/* Choose tables modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>Nomear mesa</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: "200px",
              overflow: "auto",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <NumberBoxes onClick={() => handleChangeTable(null)}></NumberBoxes>
            {reservations &&
              markNotAllowedTables().map(
                ({
                  number,
                  isNotAllowed,
                  reservation_name,
                  reservation_token,
                }) => {
                  return (
                    <NumberBoxes
                      key={number}
                      onClick={() =>
                        handleChangeTable(
                          number,
                          isNotAllowed,
                          reservation_name,
                          reservation_token,
                        )
                      }
                      style={{
                        backgroundColor:
                          parseInt(number) ===
                          parseInt(reservation.table_number)
                            ? "#9FBBC1"
                            : isNotAllowed
                              ? "#deb949"
                              : "#ffffff",
                      }}
                    >
                      {number}
                    </NumberBoxes>
                  );
                },
              )}
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </div>
      </Modal>

      <Modal show={showAcceptModal} onHide={handleCloseAcceptModal}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>
              {rejectEdition ? "Aceitar alteração" : "Aceitar reserva?"}
            </Modal.Title>
          </Modal.Header>
          {rejectEdition && reservation && reservationBeforeEdition && (
            <Modal.Body>
              <CompareChanges
                before={reservationBeforeEdition}
                after={reservation}
              />
            </Modal.Body>
          )}
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              marginLeft: "10px",
            }}
          >
            <input
              type="checkbox"
              checked={notify_customer}
              onChange={(e) => setNotify_customer(e.target.checked)}
            />
            Enviar uma notificação ao cliente
          </label>

          <Modal.Footer>
            <Button variant="success" onClick={handleAccept}>
              Sim
            </Button>
            <Button variant="danger" onClick={handleCloseAcceptModal}>
              Não
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showCancelModal} onHide={handleCloseCancelModal}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>
              {rejectEdition ? "Rejeitar alteração?" : "Rejeitar reserva?"}
            </Modal.Title>
          </Modal.Header>
          {rejectEdition && reservation && reservationBeforeEdition && (
            <Modal.Body>
              <CompareChanges
                before={reservationBeforeEdition}
                after={reservation}
              />
            </Modal.Body>
          )}
          <Modal.Footer>
            <Button variant="success" onClick={handleCancel}>
              Sim
            </Button>
            <Button variant="danger" onClick={handleCloseCancelModal}>
              Não
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showAttendanceModal} onHide={handleHideAttendanceModal}>
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar comparência?</Modal.Title>
          </Modal.Header>

          <Modal.Footer>
            <Button variant="success" onClick={() => handleAttended()}>
              Confirmar
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showChangeTablesModal}
        onHide={() => setShowChangeTablesModal(!showChangeTablesModal)}
      >
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>
              Trocar mesa
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {reservation.table_number}{" "}
              </span>
              com mesa
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {reservationToChangeNumber}{" "}
              </span>
              da reserva
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {reservationToChangeName}{" "}
              </span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Footer>
            <Button
              variant="success"
              onClick={() => changeTablesWithOtherReservation()}
            >
              Confirmar
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showNotAttendanceModal}
        onHide={handleHideDidNotAttendanceModal}
      >
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar não comparência?</Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button variant="success" onClick={() => handleNotAttended()}>
              Confirmar
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showModalRestoreReservation}
        onHide={handleHideModalRestoreReservation}
      >
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>Restaurar reserva?</Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button variant="success" onClick={handleRestoreCancel}>
              Sim
            </Button>
            <Button
              variant="danger"
              onClick={() =>
                setShowModalRestoreReservation(!showModalRestoreReservation)
              }
            >
              Não
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showSendTableReadyMessageModal}
        onHide={() =>
          setShowSendTableReadyMessageModal(!showSendTableReadyMessageModal)
        }
      >
        <div ref={statusBoxRef}>
          <Modal.Header closeButton>
            <Modal.Title>Enviar mensagem</Modal.Title>
          </Modal.Header>
          <Modal.Body>Avisar cliente que a sua mesa esta pronta?</Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={sendTheTableReadyMessage}>
              Enviar
            </Button>
            <Button
              variant="danger"
              onClick={() =>
                setShowSendTableReadyMessageModal(
                  !showSendTableReadyMessageModal,
                )
              }
            >
              Não Enviar
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <ConfirmationModal
        show={showChangeStatusModal}
        onHide={() => setShowChangeStatusModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmar alteração</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem a certeza que deseja alterar o estado para{" "}
          <b>{getReservationStatusAbreviationTranslation(selectedStatus)}</b>?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowChangeStatusModal(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              patchReservationStatus(reservation.id, selectedStatus);
              setShowChangeStatusModal(false);
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </ConfirmationModal>
    </>
  );
}

export default ReservationStatusBox;
